export function BrandedRouteFallback() {
  return (
    <main className="route-fallback">
      <div className="town-mark" aria-hidden="true">
        <span>LL</span>
        <i />
      </div>
      <span>Opening your town...</span>
    </main>
  );
}
